var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useRef, useContext } from 'react';
import { useHistory } from 'react-router';
import { Title, TagsButtons, DropdownButton, AlbumRow, DispatchEdit } from '..';
import { DynamicPlaylist, AddToHistory, PlaybackManager, PlayerState, isSoundPackagePending } from '../..';
import { FAV_FILLED_SVG, FAV_SVG, PAUSE_RED_SVG, TRIANGLE_RED_SVG, DOWNLOAD_RED_SVG, PAPER_PLANE_RED_SVG, LAPTOP_RED_SVG, RINGS_SVG } from '../../assets';
import { CuratedPackageWrapper, playerContext } from '../../context';
import { useOnClickOutside } from '../../hooks';
import { CuratedPackageManager } from '../../manager';
import mergeRefs from '../../util/merge-ref';
import ShareModal from '../ShareModal';
import Button from '../buttons/Button';
import { BPMSoundsGeneric } from '../../generic';
var AlbumHeader = function (props) {
    var playContext = useContext(playerContext);
    var pack = props.pack;
    var shareUrl = window.location.href;
    var _a = useState(false), showMore = _a[0], setShowMore = _a[1];
    var _b = useState(false), showModal = _b[0], setshowModal = _b[1];
    var _c = useState({ show: false }), similar = _c[0], setSimilar = _c[1];
    var description = useRef(null);
    var shareContainer = useRef(null);
    var shareButton = useRef(null);
    var internallist = React.useRef(new DynamicPlaylist([], {
        history_mode: AddToHistory.ALL
    }, pack.id, false));
    var history = useHistory();
    useOnClickOutside(shareContainer, function () { return setshowModal(false); });
    React.useEffect(function () {
        var pack = props.pack;
        internallist.current.replace([pack.demo_file_url ? {
                sound: PlaybackManager.packageToPlayableSound(pack, 1),
                playlist: internallist.current
            } : undefined, pack.demo_file_url_2 ? {
                sound: PlaybackManager.packageToPlayableSound(pack, 2),
                playlist: internallist.current
            } : undefined].filter(Boolean));
        PlaybackManager.getInstance().getContentManager().replaceLists(internallist.current);
    }, [props.pack]);
    var showSimilar = function (show) {
        if (show && !similar.similarSoundPacks) {
            if (pack.__typename == 'Curated') {
            }
            else {
                BPMSoundsGeneric.get().loadSimiliarSoundPackages(props.pack).then(function (_a) {
                    var data = _a.data;
                    setSimilar(function (f) {
                        return __assign(__assign({}, f), { similarSoundPacks: data.packs });
                    });
                });
            }
        }
        setSimilar(function (f) {
            return __assign(__assign({}, f), { show: show });
        });
    };
    var style = {};
    if (pack.logo_gradient_colors) {
        var top_1 = 'black';
        var top_2 = pack.logo_gradient_colors.split(', ')[0];
        var top_3 = pack.logo_gradient_colors.split(', ')[1];
        var background = "linear-gradient(-90deg, " + top_1 + " 0%, " + top_2 + " 50%, " + top_3 + " 100%)";
        style = ({ background: background });
    }
    function playDemo(demo) {
        if (playContext.media && PlaybackManager.isSoundEqualSoundPackage(pack, playContext.media.sound) == demo) {
            if (playContext.state == PlayerState.Playing) {
                PlaybackManager.getInstance().pause();
            }
            else {
                PlaybackManager.getInstance().play();
            }
        }
        else {
            PlaybackManager.getInstance().startTrack(internallist.current.tracks()[demo - 1]);
        }
    }
    return (React.createElement("div", { className: "IndividualPack" + (isSoundPackagePending(pack) ? ' not-approved' : '') },
        React.createElement(CuratedPackageWrapper, { curated: pack }, function (pack) {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { className: "background-image", style: style },
                    React.createElement("div", { className: "content-wrapper" },
                        React.createElement("div", { className: "album-wrapper" },
                            React.createElement("img", { className: "album-cover", src: pack.artwork_url, alt: "album cover" }),
                            React.createElement("img", { className: "heart-svg-mobile " + (pack.is_favorited ? 'no-fill' : ''), src: pack.is_favorited ? FAV_FILLED_SVG : FAV_SVG, alt: "heart", onClick: function () {
                                    if (pack.__typename == 'Curated') {
                                        props.onCuratedLikeToggled && props.onCuratedLikeToggled(pack);
                                    }
                                    else {
                                        props.onSoundPackageLikeToggled && props.onSoundPackageLikeToggled(pack);
                                    }
                                } })),
                        React.createElement("div", { className: "content-container" },
                            React.createElement(Title, { titleText: pack.name, fontSize: '3rem', margins: '0 0 1rem 0' }),
                            pack.Label &&
                                React.createElement("div", { className: "label" },
                                    "by ",
                                    React.createElement("span", { className: "name", onClick: function () { return history.push('/labels/' + pack.Label.name); } }, pack.Label.name),
                                    React.createElement("div", { className: "genre-tag-mobile-wrapper" }, pack.Genre && React.createElement(Button, { className: 'genre-tag-mobile', buttonText: pack.Genre.name, onClick: function () { return history.push('/genre/' + encodeURIComponent(pack.Genre.name)); } }))),
                            React.createElement("div", { className: "tags-container" },
                                pack.Genre && React.createElement(Button, { className: 'genre-tag', buttonText: pack.Genre.name, onClick: function () { return history.push('/genre/' + encodeURIComponent(pack.Genre.name)); } }),
                                React.createElement(TagsButtons, { buttons: props.tags.map(function (tag) {
                                        return {
                                            buttonText: tag.name,
                                            height: '32px',
                                            rightTextFontSize: '1.3rem',
                                            buttonTextRight: tag.sound_count,
                                            selected: (props.selectedTags || []).includes(tag.id) || (props.selectedTags || []).includesLowercase(tag.name),
                                            onClick: function () {
                                                props.onTagClick(tag);
                                            }
                                        };
                                    }) })),
                            React.createElement("div", { className: 'subtext' },
                                React.createElement(DispatchEdit, { identifier: "soundpacakge:description:" + pack.id, commitChanges: function (description) {
                                        return BPMSoundsGeneric.get().updateSoundPackage(pack.id, { description: description }).then(function (pack) {
                                            CuratedPackageManager.getInstance().updateCuratedPackage(pack);
                                        });
                                    } }, function (_a) {
                                    var containerProps = _a.containerProps, ref = _a.ref;
                                    return React.createElement("span", __assign({ key: '1', className: "description " + (showMore ? 'un-truncate' : '') }, containerProps, { ref: mergeRefs([description, ref]), style: showMore && description.current ? { height: 'auto' } : {} }), pack.description);
                                }),
                                description.current && description.current.scrollHeight > 63 ?
                                    React.createElement("span", { className: "showMore", onClick: function () {
                                            if (showMore)
                                                setShowMore(false);
                                            else
                                                setShowMore(true);
                                        } }, showMore ? 'READ LESS' : 'READ MORE')
                                    :
                                        null),
                            React.createElement("div", { className: "dropdownButtons" },
                                pack.demo_file_url && React.createElement(DropdownButton, { hover: true, key: playContext.state, buttonText: 'Play Demo', buttonImageLeft: (function () {
                                        if (playContext.media && PlaybackManager.isSoundEqualSoundPackage(pack, playContext.media.sound) !== false && playContext.state == PlayerState.Playing) {
                                            return PAUSE_RED_SVG;
                                        }
                                        return TRIANGLE_RED_SVG;
                                    })(), buttonImageWidth: '10', menuItems: pack.demo_file_url_2 ? [{
                                            text: 'Play Demo 2',
                                            onClick: function () {
                                                playDemo(2);
                                            }
                                        }] : undefined, onClick: function () {
                                        playDemo(1);
                                    } }),
                                React.createElement(DropdownButton, { buttonText: 'Download', buttonImageLeft: DOWNLOAD_RED_SVG, buttonImageWidth: '18', onClick: function () {
                                        if (pack.__typename == 'SoundPackage') {
                                            return props.onSoundPackageDownload(pack, true);
                                        }
                                        else {
                                            return props.onCuratedDownload(pack, true);
                                        }
                                    } }),
                                React.createElement("div", { id: "share" },
                                    React.createElement(DropdownButton, { hover: true, buttonText: 'Share', buttonImageLeft: PAPER_PLANE_RED_SVG, buttonImageWidth: '23', onClick: function () {
                                            setshowModal(!showModal);
                                        } })),
                                React.createElement(ShareModal, { showModal: showModal, onShowModalChange: function (change) { setshowModal(change); }, shareTitle: 'BPM Create: ' + pack.name, shareAnchor: document.getElementById('share'), shareURL: window.location.href, remove: ['linkedin'] }),
                                pack.video_url && React.createElement(DropdownButton, { buttonText: 'Video Tutorial', buttonImageLeft: LAPTOP_RED_SVG, buttonImageWidth: '25', onClick: function () {
                                        window.open(pack.video_url, '__blank');
                                    } }),
                                React.createElement("div", { className: "findSimilar" },
                                    pack.__typename == 'SoundPackage' && React.createElement(DropdownButton, { buttonText: 'Find Similar Packs', buttonImageLeft: RINGS_SVG, buttonImageWidth: '28', onClick: function () { return showSimilar(!similar.show); } }),
                                    React.createElement("img", { className: "heart-svg " + (pack.is_favorited ? 'no-fill' : ''), src: pack.is_favorited ? FAV_FILLED_SVG : FAV_SVG, alt: "heart", onClick: function () {
                                            if (pack.__typename == 'Curated') {
                                                props.onCuratedLikeToggled && props.onCuratedLikeToggled(pack);
                                            }
                                            else {
                                                props.onSoundPackageLikeToggled && props.onSoundPackageLikeToggled(pack);
                                            }
                                        } })))))),
                similar.show && React.createElement("div", { className: 'similar-packs' },
                    React.createElement(AlbumRow, __assign({}, props, { context: 'similar_packs', loading: similar.similarSoundPacks == undefined, soundPackages: similar.similarSoundPacks, title: 'Similar Packs', viewAll: false }))));
        })));
};
export default AlbumHeader;
//# sourceMappingURL=AlbumHeader.js.map